import React, { useState, useEffect } from 'react'
import api from '../../config/api'
import { makeStyles } from '@material-ui/core/styles';
import {
    Typography,
    TextField,
    Select,
    Grid,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Snackbar,
    Box
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useForm, Controller } from "react-hook-form";
import NumberFormat from 'react-number-format';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useHistory } from 'react-router-dom';

interface Category {
    id: number
    description: string

}
interface Unity {
    id: number
    description: string
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    form: {
        maxWidth: '1000px',
        width: '100%',
        marginTop: '2rem'
    },
    title: {
        fontWeight: 600
    }
}));

const schema = yup.object().shape({
    description: yup.string().required(),
    cod: yup.number().required(),
    year: yup.number().required().moreThan(2000, 'Data Invalida').lessThan(3000, 'Data Invalida'),
    category_id: yup.number().required(),
    unity_id: yup.number().required(),
    value: yup.number().required(),
    max_value: yup.number().required(),
    min_value: yup.number().required(),
    production: yup.number().required(),
    production_cost: yup.number().required(),
    max_production_cost: yup.number().required(),
    min_production_cost: yup.number().required()
});

function CreateAgroProductNew() {

    const [categories, setCategories] = useState<Category[]>([])
    const [unitys, setUnitys] = useState<Unity[]>([])
    const { handleSubmit, control, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema)
    });
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");

    const history = useHistory()

    useEffect(() => {
        async function fetch() {
            const requestUnitys = await api.get('/unitys')
            const { unitys } = requestUnitys.data
            setUnitys(unitys)
            const requestCategories = await api.get('/categories')
            const { categories } = requestCategories.data
            setCategories(categories)
        }
        fetch()
    }, [])

    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
        history.push('/agro-products')
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    function NumberFormatCustom(props: any) {
        const { inputRef, onChange, ...other } = props;
        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator="."
                decimalSeparator=","
                isNumericString
                prefix="R$ "
                allowNegative={false}
            />
        );
    }

    function YearFormatCustom(props: any) {
        const { inputRef, onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                format="####"
                allowNegative={false}
            />
        );
    }




    const onSubmit = async (data: any) => {
        if (data.value > data.max_value || data.value < data.min_value) {
            setOpenFailed(true)
            setErrorMessage('Valores inválidos ')
            return
        }
        if (data.production_cost > data.max_production_cost || data.production_cost < data.min_production_cost) {
            setOpenFailed(true)
            setErrorMessage('Valores inválidos ')
            return
        }
        try {
            const request = await api.post('/agroproducts', {
                ...data
            }).then(response => { 
                    setOpenSuccess(true)
            })
            .catch(error => {
                 if (error.response.data.error === "Agro Product already cadastred") {
                    setOpenFailed(true)
                    setErrorMessage('Este empreendimento já está cadastrado')
                } 
            });
        } catch (err) {
            //@ts-ignore
            if (err.message === "Missing field") {
                setOpenFailed(true)
                setErrorMessage('Digite todos os campos')
            }
            //@ts-ignore
            else {
                setOpenFailed(true)
                setErrorMessage('Erro desconhecido')
            }
        }
    }

    const handleClean = () => {
        reset({
            description: '',
            cod: '',
            year: '',
            category_id: '',
            unity_id: '',
            value: '',
            max_value: '',
            min_value: '',
            production: '',
            production_cost: '',
            max_production_cost: '',
            min_production_cost: ''
        })
    }

    const classes = useStyles();

    return (
        <>
            <form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h4" className={classes.title} >
                    Criar uma nova cultura
                </Typography>
                <Grid container spacing={3} className={classes.form}>
                    <Grid item xs={12} sm={6}>
                        <Controller
                            control={control}
                            name="description"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Descrição da Cultura"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Ex: Soja - PR"
                                    value={value}
                                    error={errors.description}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Controller
                            control={control}
                            name="cod"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Codigo"
                                    fullWidth
                                    variant="outlined"
                                    error={errors.cod}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Controller
                            control={control}
                            name="year"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Ano"
                                    fullWidth
                                    variant="outlined"
                                    value={value}
                                    error={errors.year}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: YearFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Controller
                            control={control}
                            name="category_id"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Categoria</InputLabel>
                                    <Select
                                        label="Categoria"
                                        fullWidth
                                        variant="outlined"
                                        error={errors.category_id}
                                        value={value}
                                        onChange={onChange}
                                        onBlur={onBlur}
                                    >
                                        {categories.map(el => (
                                            <MenuItem value={el.id} key={el.id}>{el.description}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl >
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Controller
                            control={control}
                            name="unity_id"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Unidade de medida</InputLabel>
                                    <Select
                                        label="Unidade de medida"
                                        fullWidth
                                        error={errors.unity_id}
                                        variant="outlined"
                                        value={value}
                                        onChange={onChange}
                                        onBlur={onBlur}
                                    >
                                        {unitys.map(el => (
                                            <MenuItem value={el.id} key={el.id}>{el.description}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl >
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <Controller
                            control={control}
                            name="production"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Produção Média por Hectare"
                                    fullWidth
                                    variant="outlined"
                                    value={value}
                                    error={errors.production}
                                    onChange={onChange}
                                    onBlur={onBlur}

                                />
                            )}
                        />

                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="value"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Valor"
                                    fullWidth
                                    variant="outlined"
                                    error={errors.value}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="max_value"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Valor Máximo"
                                    fullWidth
                                    variant="outlined"
                                    error={errors.max_value}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="min_value"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Valor Mínimo"
                                    fullWidth
                                    variant="outlined"
                                    value={value}
                                    error={errors.min_value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="production_cost"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Custo de Produção"
                                    fullWidth
                                    variant="outlined"
                                    error={errors.production_cost}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="max_production_cost"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Custo de Produção Máximo"
                                    fullWidth
                                    variant="outlined"
                                    value={value}
                                    error={errors.max_production_cost}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="min_production_cost"
                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                <TextField
                                    label="Custo de Produção Mínimo"
                                    fullWidth
                                    variant="outlined"
                                    error={errors.min_production_cost}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom
                                    }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Box style={{ marginTop: 40 }}>
                    <Button
                        variant="contained"
                        style={{ height: 40, width: 180, marginRight: 20 }}
                        color="primary"
                        type={"submit"}
                    >Criar Cultura</Button>
                    <Button
                        variant="contained"
                        style={{ height: 40, width: 180 }}
                        color="primary"
                        onClick={handleClean}
                    >Limpar</Button>
                </Box>
            </form >
            <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success">
                    Cultura criada com sucesso!
                </Alert>
            </Snackbar>

            <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                <Alert onClose={handleCloseFailed} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default CreateAgroProductNew


